import { useSiteData } from "../context/SiteDataContext";
import coin from "/tud.svg";
import profile from "/profile.svg";
import { useState, useEffect } from "react";

const Header: React.FC = () => {
  const site = useSiteData();
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    setImageLoaded(false); // Reset loading state on page change
  }, [site.data.user.photo_url]);

  return (
    <div className="bg-[#71ABFF1A] bg-opacity-50 backdrop-blur rounded-lg p-4 mb-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <img 
            src={imageError || !site.data.user.photo_url || !imageLoaded ? profile : site.data.user.photo_url} 
            alt="user" 
            className="rounded-full w-10 h-10 flex items-center justify-center mr-2" 
            onError={() => setImageError(true)}
            onLoad={() => setImageLoaded(true)}
          />
          <div>
            <h2 className="text-xl font-bold">{site.data.user.first_name}</h2>
            <p className="text-md text-gray-400">@{site.data.user.username}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xl font-bold flex items-center justify-center">{site.data.user.balance} <img src={coin} alt="coin" className="w-5 h-5 ml-2" /></p>
          <p className="text-md text-gray-400">{site.data.user.point} ⭐️</p>
        </div>
      </div>
    </div>
  );
};

export default Header;